const cards = [
  {
    id: 1,
    tag: '顶流恋情',
    title: '顶流男星深夜密会神秘女子，工作室凌晨紧急发布声明回应',
    summary: '据知情人士透露，该男星与女方相识于年初某品牌活动，目前已交往数月。工作室声明称二人仅为普通朋友关系。',
    time: '2小时前',
    views: '892万',
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20news%20editorial%20style%20with%20soft%20dramatic%20lighting%2C%20celebrity%20gossip%20magazine%20cover%20aesthetic%2C%20warm%20coral%20and%20cream%20tones%2C%20modern%20minimal%20composition%2C%20professional%20photojournalism%20quality%2C%20clean%20background&width=640&height=400&seq=card-01-cg&orientation=landscape',
  },
  {
    id: 2,
    tag: '综艺翻车',
    title: '热门综艺录制现场突发状况，导演组措手不及紧急暂停',
    summary: '某S+级综艺节目最新一期录制时，嘉宾在游戏环节发生意外，节目组已第一时间送医并宣布延期录制。',
    time: '4小时前',
    views: '756万',
    image: 'https://readdy.ai/api/search-image?query=TV%20variety%20show%20production%20set%20with%20dramatic%20lighting%2C%20behind%20the%20scenes%20entertainment%20photography%2C%20warm%20golden%20and%20coral%20tones%2C%20editorial%20magazine%20style%2C%20professional%20quality%2C%20clean%20composition&width=640&height=400&seq=card-02-cg&orientation=landscape',
  },
  {
    id: 3,
    tag: '网红塌房',
    title: '知名网红被曝偷税漏税，多个社交账号已被平台封禁处理',
    summary: '税务部门已介入调查，该网红关联的多家MCN机构连夜发布解约声明，累计粉丝量超5000万一夜归零。',
    time: '6小时前',
    views: '634万',
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20influencer%20dramatic%20scene%20with%20smartphone%20and%20notification%20alerts%2C%20modern%20digital%20lifestyle%20photography%2C%20warm%20coral%20and%20amber%20tones%2C%20editorial%20style%2C%20clean%20background%2C%20high%20quality&width=640&height=400&seq=card-03-cg&orientation=landscape',
  },
  {
    id: 4,
    tag: '明星婚变',
    title: '当红女星婚变内幕独家揭秘，知情人曝光分居时间线',
    summary: '据多位圈内人士证实，两人已于半年前分居，财产分割谈判陷入僵局。工作室暂未回应相关询问。',
    time: '8小时前',
    views: '521万',
    image: 'https://readdy.ai/api/search-image?query=Celebrity%20relationship%20drama%20editorial%20photography%20with%20split%20composition%2C%20emotional%20tension%20aesthetic%2C%20warm%20coral%20pink%20and%20cream%20tones%2C%20magazine%20cover%20style%2C%20professional%20photojournalism&width=640&height=400&seq=card-04-cg&orientation=landscape',
  },
  {
    id: 5,
    tag: '剧集路透',
    title: '最新古装大剧路透照流出，男主角造型引发网友两极热议',
    summary: '该剧投资超5亿，原定明年暑期档播出。路透照片曝光后，服化道设计成为社交平台热搜话题。',
    time: '10小时前',
    views: '438万',
    image: 'https://readdy.ai/api/search-image?query=Historical%20costume%20drama%20film%20set%20leaked%20photo%20aesthetic%2C%20traditional%20Chinese%20elements%20with%20modern%20editorial%20photography%2C%20warm%20golden%20and%20cream%20tones%2C%20professional%20quality%2C%20clean%20composition&width=640&height=400&seq=card-05-cg&orientation=landscape',
  },
  {
    id: 6,
    tag: '音乐节',
    title: '某头部音乐节完整阵容正式官宣，票价暴涨引发粉丝争议',
    summary: '本次音乐节阵容涵盖国内外30余组艺人，早鸟票开售即罄。普通票较去年上涨近40%，引发热议。',
    time: '12小时前',
    views: '367万',
    image: 'https://readdy.ai/api/search-image?query=Music%20festival%20crowd%20with%20colorful%20stage%20lights%2C%20vibrant%20concert%20atmosphere%2C%20warm%20golden%20and%20coral%20tones%2C%20editorial%20event%20photography%20style%2C%20professional%20quality%2C%20clean%20composition&width=640&height=400&seq=card-06-cg&orientation=landscape',
  },
  {
    id: 7,
    tag: '恋情整理',
    title: '娱乐圈最新恋情时间线完整整理，多对CP浮出水面引猜测',
    summary: '从年初至今已有十余对明星恋情曝光或确认，本网整理完整时间线，带你一口气吃完今年所有恋情瓜。',
    time: '14小时前',
    views: '295万',
    image: 'https://readdy.ai/api/search-image?query=Celebrity%20couple%20romance%20timeline%20collage%20editorial%20style%2C%20soft%20romantic%20lighting%2C%20warm%20pink%20and%20cream%20tones%2C%20magazine%20layout%20aesthetic%2C%20professional%20photography%20quality%2C%20clean%20background&width=640&height=400&seq=card-07-cg&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">热门吃瓜</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            全网最新最热的吃瓜内容实时更新，51吃瓜网在线汇聚今日最受关注的娱乐八卦与黑料视频
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {cards.map((card) => (
            <article
              key={card.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium whitespace-nowrap">
                  {card.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-medium text-sm md:text-base text-foreground-900 leading-snug mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                  {card.summary}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {card.time}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {card.views}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}